import React from 'react';
import isNil from 'utils/isNil';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import colorTypeHelper from 'utils/colorTypeHelper';
import useSectionImages from 'hooks/useSectionImages';

export const SectionLayout = ({
  children,
  backgroundImg,
  backgroundImageTypeWithPosition,
  backgroundColor,
  innerContainerStyles,
  ...otherProps
}) => {
  const pageImages = useSectionImages();

  let blueLightCornerRight, blueLightSideRight, blueDarkCornerLeft, blueDarkCornerRight;
  pageImages.edges.forEach(imageItem => {
    if (imageItem.node.internalName === 'Background blue-dark-corner-right') {
      blueDarkCornerRight = !isNil(imageItem.node.image) ? imageItem.node.image.file.url : '';
    } else if (imageItem.node.internalName === 'Background blue-dark-corner-left') {
      blueDarkCornerLeft = !isNil(imageItem.node.image) ? imageItem.node.image.file.url : '';
    } else if (imageItem.node.internalName === 'Background blue-light-corner-right') {
      blueLightCornerRight = !isNil(imageItem.node.image) ? imageItem.node.image.file.url : '';
    } else if (imageItem.node.internalName === 'Background blue-light-side-right') {
      blueLightSideRight = !isNil(imageItem.node.image) ? imageItem.node.image.file.url : '';
    }
  });

  const BackgroundCornerImg = () => {
    let backgroundImage = null;
    if (backgroundImageTypeWithPosition !== 'none' && !isNil(backgroundImageTypeWithPosition)) {
      const backgroundClassName = backgroundImageTypeWithPosition;
      switch (backgroundImageTypeWithPosition) {
        case 'blue-light-corner-right':
          backgroundImage = blueLightCornerRight;
          break;
        case 'blue-light-side-right':
          backgroundImage = blueLightSideRight;
          break;
        case 'blue-dark-corner-left':
          backgroundImage = blueDarkCornerLeft;
          break;
        case 'blue-dark-corner-right':
          backgroundImage = blueDarkCornerRight;
          break;
        default:
          backgroundImage = null;
      }
      return (
        <img
          src={backgroundImage}
          alt={backgroundImageTypeWithPosition}
          className={backgroundClassName}
        />
      );
    } else return null;
  };

  const bgColor = colorTypeHelper[backgroundColor];
  return (
    <Layout
      bgColor={bgColor}
      bgImg={backgroundImg}
      gradientDirection={otherProps.gradientDirection}
      {...otherProps}
    >
      <BackgroundCornerImg />
      <InnerContainer
        className={`section-layout--inner-container ${innerContainerStyles}`}
        contentBelowSection={otherProps.contentBelowSection}
      >
        {children}
      </InnerContainer>
    </Layout>
  );
};

SectionLayout.propTypes = {
  backgroundImg: PropTypes.string, // background image
  backgroundColor: PropTypes.string,
  backgroundImageTypeWithPosition: PropTypes.string,
  contentBelowSection: PropTypes.bool,
};

const InnerContainer = styled.div`
  width: 100%;
  max-width: 1296px;
  margin: 0px auto;
  padding-top: 60px;
  padding-bottom: ${props => (props.contentBelowSection ? '0px' : '75px')};
  padding-left: 28px;
  padding-right: 28px;
  position: relative;

  @media (max-width: 768px) {
    padding: 60px 18px 48px;
  }

  @media (max-width: 576px) {
    padding-top: 48px;
  }
`;

const Layout = styled.div`
  background-image: ${props => {
    return `${
      props.gradientDirection
        ? `linear-gradient(${props.gradientDirection.toLowerCase()}, rgba(0,0,0,1) 0%, rgba(0,212,255,0) 78%),`
        : ''
    }
    ${props.bgImg ? `url(${props.bgImg})` : ''}`;
  }};
  background-color: var(${props => props.bgColor});
  background-size: cover;
  background-repeat: no-repeat;
  .blue-light-corner-right {
    position: absolute;
    right: 0;
    z-index: -1;
  }

  .blue-light-side-right {
    position: absolute;
    right: 20%;
    z-index: -1;
  }
  .blue-dark-corner-left {
    position: absolute;
    left: 0;
    z-index: -1;
  }
  .blue-dark-corner-right {
    position: absolute;
    z-index: -1;
    right: 0;
  }
  ${props =>
    props.bgImg &&
    `@media (max-width: 576px) {
      background-image:
      url(${props.bgImg})
      background-position: center;
      background-size: cover;
    }`}
`;
